<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row class="m-3">
                <b-col>
                    <div>
                        <p class="font-weight-bold">D. SCHOLARSHIPS/TUITION ASSISTANCE/AWARDS.</p>
                    </div>
                    <b-table-simple
                        responsive
                        striped
                        hover
                        class="text-sm text-md-md"
                    >
                        <b-thead>
                            <b-tr>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr
                                v-for="(menu, j) in data"
                                :key="j"
                                class="py-2 py-md-3"
                            >
                                <b-td class="font-weight-bold">{{ menu.key }}</b-td>
                                <b-td>
                                    <span style="white-space: pre-line;">{{ menu.value }}</span>
                                </b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                    <div>
                        <p>*Students who earn a scholarship/tuition discount/award of any category should meet the
                            following criteria to maintain the award:
                            <br>
                            1)	Continuously enroll in courses each module (unless taking approved time off)
                            and
                            <br>
                            2)	Maintain a minimum attendance rate of 80% for any Module and
                            <br>
                            3)	Avoid any disciplinary action for any reason. <br>
                            Scholarships, tuition discounts and/or awards are available for students who qualify. That is
                            why continuing your studies at BAU in the Mentora ESL Program is essential, as another
                            student might have been rejected at the time of your application.
                            Therefore, if a student who was awarded any scholarship or tuition assistance withdraws from
                            the Mentora ESL Program and does not transfer into the BAU degree program, they will not
                            receive a refund of the deposit, and/or may be required to repay the award or pay an
                            Administrative Service Fee. BAU Mentora ESL Program is committed to re-use these funds for
                            students who need or earn financial assistance. If a new student wishes to transfer their SEVIS record to another institution prior to or during the initial session (3 modules), BAU will not refund any portion of their tuition deposit or fees. Additionally, the student will be required to pay an Administrative Service Fee of $1,650.
                        </p>
                    </div>
                </b-col>

                <b-col cols="12" class="mt-3">
                    <b-row class="d-flex align-items-center flex-column flex-md-row  justify-content-md-between">
                        <b-col cols="12" md="8" class="mb-2 mb-md-0 d-flex flex-row-md-reverse flex-row">
                            <ValidationProvider
                                name="status"
                                rules="required"
                                v-slot="{ valid, errors }"
                            >
                                <div class="d-flex flex-row-reverse">
                                    <b-form-checkbox
                                        id="checkbox-1"
                                        v-model="form.status"
                                        name="checkbox-1"
                                        value="accepted"
                                        :unchecked-value="null"
                                        class="text-sm text-md-md ml-4"
                                    >
                                    </b-form-checkbox
                                    >
                                    <p>
                                        I read and confirm that I understand the information in Section D.
                                    </p>
                                </div>
                                <b-form-invalid-feedback v-if="errors[0]">
                                    {{ errors[0] }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="4" class="text-md-right mt-3">
                            <b-button
                                type="submit"
                                @click="next"
                                variant="primary"
                                class="w-100 w-md-auto"
                            >
                                {{ $t('next') }}
                            </b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </ValidationObserver>


    </div>
</template>
<script>
import moment from "moment";

export default {
    props:{
        studentInformation: {
            type: Object,
        }
    },
    data() {
        return {
            form: {},
        }
    },

    computed: {
        data() {
            const data = this.studentInformation ?? {};
            const firstModuleDate = data?.first_module_date;
            let isAugust24 = ['2026-08-24', '2026-09-21', '2026-10-19'].includes(firstModuleDate) || ['08/24/2026', '09/21/2026', '10/19/2026'].includes(firstModuleDate)
            if(!isAugust24 && moment().format('YYYY-MM-DD')<'2026-11-01' && (firstModuleDate == null || String(firstModuleDate).trim() === '')){
              isAugust24 = true
            }

            const rows = [
                {
                    key: 'Type of Scholarship/Discount/Award Applied During Module:',
                    value: isAugust24
                        ? 'First Module Tuition Free; $400 Tuition per Module for the Following 11 Modules'
                        : data.scholarship_name ?? '',
                },
                {
                    key: 'Start Date of Module and End Date of Module which Scholarship/Discount/Award Applied:',
                    value: isAugust24
                        ? 'New Students with an August 24, 2026 Start Date: August 24, 2026 - July 19, 2027 module\nNew Students with a September 21, 2026 Start Date: September 21, 2026 - August 16, 2027 module\nNew Students with a October 19, 2026 Start Date: October 19, 2026 - September 13, 2027 module'
                        : Number(data.total_discount_amount) > 0
                            ? [data.active_module_start_date, data.active_module_end_date].filter(Boolean).join(' - ')
                            : '',
                },
                {
                    key: 'Amount That Will Be Applied This Module:',
                    value: isAugust24
                        ? 'First Module: Tuition Free + mandatory fee.\nFollowing 11 Modules: Tuition is $400 per module + mandatory fees.'
                        : this.currencyFormat(data.discount_amount ?? 0),
                },
                {
                    key: 'Additional Awards Given for This Module:',
                    value: isAugust24 ? '$0' : this.currencyFormat(data.additional_awards_amount ?? 0),
                },
            ];
            if (isAugust24 || data.promotion_code) {
                rows.push({
                    key: 'Description',
                    value: isAugust24
                        ? 'New Enrollment Promotion: First module tuition free with the mandatory fee, followed by $400 tuition + mandatory fee per module for the next 11 modules.\nStarting from the 13th module, students will pay the current regular tuition rate + mandatory fees per module.'
                        : data.promotion_code,
                });
            }
            return rows;
        },
    },
    methods: {
        async next(){
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid){
                this.$emit('next',1)
            }

        },
        back(){
            this.$emit('back', -1);
        }
    },
    created() {
        window.scrollTo(0,0)
    },
}
</script>
